import React, { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { ThemeProvider as MuiThemeProvider, StylesProvider, createTheme } from "@material-ui/core/styles";
import ReactGA from "react-ga4";

// STYLES
import { UtilityStyles } from "./Styles/Utils";
import { THEME_SETTINGS } from "./themeSettings";
// HELPERS
import { Socket } from "Helpers/SocketClient";
// COMPONENTS
import Website from "./Components/Website";
// REDUX
import { store } from "./Redux/Store";
import "./App.css"
import GAListener from "GAListener";

const MEASUREMENT_ID = "G-7EX0MP1GE0";

// if (process.env.NODE_ENV === "staging") {
// 	ReactGA.initialize(MEASUREMENT_ID, { debug_mode: true });
// 	console.log("GA Debug Mode Enabled (local)");
// } else {
// 	ReactGA.initialize(MEASUREMENT_ID);
// }
ReactGA.initialize(MEASUREMENT_ID);

const theme = createTheme(THEME_SETTINGS);

function App() {
	useEffect(() => {
		return () => {
			if (Socket) Socket.close();
		};
	}, []);

	return (
		<Provider store={store}>
			<BrowserRouter basename={process.env.REACT_APP_BASE_PATH}>
				<GAListener />

				<StylesProvider injectFirst>
					<MuiThemeProvider theme={theme}>
						<Website />
						<UtilityStyles />
					</MuiThemeProvider>
				</StylesProvider>
			</BrowserRouter>
		</Provider>
	);
}

export default App;
